import { Logo } from '@cypro/ui/components/ui/logo'
import { Flex, Text } from '@chakra-ui/react'
import { useTranslate } from '@tolgee/react'

export function AuthHeader() {
  const {t} = useTranslate('auth')

  return (
    <header>
      <Flex justifyContent="space-between" alignItems="center" width="100%" padding="8">
        <Logo />
        <Text fontSize="sm" color="fg.subtle">
          {t('need_help')}
        </Text>
      </Flex>
    </header>
  )
}
